module.exports = __webpack_public_path__ + "img/500.5307ea9a.gif";